const routeTo = (to) => {
    return to.substring(1).replace("/:id", "").replace("/:page?", "").replace("/", "-")
}

export default routeTo
